import React, { Component } from 'react';
import { Route, Router } from 'react-router-dom';
import history from './history';

import { FrontPage } from './components/FrontPage'
import { Privacy } from './components/Privacy'



class App extends Component {
  constructor(props) {
    super(props)

    this.makeRoutes = this.makeRoutes.bind(this)
  }

  makeRoutes() {
    return (
      <Router history={history}>
        <div>
          {/*
          <Route exact path="/" render={(props) => <FrontPage {...props} />} />
          <Route exact path="/" render={(props) => <SandboxPage {...props} />} />
          */}
          <Route exact path="/" render={(props) => <FrontPage {...props} />} />
          <Route exact path="/privacy" render={(props) => <Privacy {...props} />} />
        </div>
      </Router>
    )
  }

  // sky blue
  // background-color: #D2E8FC;

  render() {
    return (
      <div className="App">
        { this.makeRoutes() }
      </div>
    );
  }
}

export default App;
